module.exports = __webpack_public_path__ + "src/assets/images/honmachi_mask.png?31a3caf6d9689d5c86097dc21f610fb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honmachi_mask.png
// module id = 878
// module chunks = 0